/* Elirati — A/B tests du Labo (dashboard.elirati.com/labo).
 * Chargé de façon bloquante dans <head> : la version est posée sur <html> avant l'affichage (pas de clignotement).
 * Hachage et répartition identiques à dashboard/src/lib/ab/assign.ts (vérifié par theme-script.test.ts).
 * En cas d'erreur : aucune classe, aucun code → tout le monde voit la version normale. */
(function (w) {
  var API = 'https://dashboard.elirati.com/api/ab/collect';
  var BOT = /bot|crawl|spider|headless|lighthouse|preview|facebookexternalhit|bingpreview|pingdom/i;
  var LOCALE = /^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i;

  function fnv1a(s) {
    var h = 0x811c9dc5;
    for (var i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 0x01000193) >>> 0;
    }
    return h >>> 0;
  }
  function bucket(vid, slug) { return fnv1a(vid + ':' + slug) % 100; }
  function pick(split, b) {
    var keys = Object.keys(split).sort(), total = 0, acc = 0, i;
    for (i = 0; i < keys.length; i++) total += split[keys[i]];
    var x = (b * total) / 100;
    for (i = 0; i < keys.length; i++) { acc += split[keys[i]]; if (x < acc) return keys[i]; }
    return keys[keys.length - 1];
  }
  function noSlash(p) { return p.length > 1 ? (p.replace(/\/+$/, '') || '/') : p; }
  function glob(pattern, path) {
    var re = new RegExp('^' + noSlash(pattern).replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*') + '$');
    return re.test(noSlash(path));
  }
  function stripLocale(p) { return p.replace(LOCALE, '') || '/'; }

  w.ElAB = { fnv1a: fnv1a, bucket: bucket, pick: pick, glob: glob, stripLocale: stripLocale };
  if (!w.document) return;
  var d = w.document;

  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function low(c) { return String(c).toLowerCase(); }
  function safeDecode(s) { try { return decodeURIComponent(s); } catch (e) { return ''; } }
  function getCookie(name) {
    var m = d.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? safeDecode(m[1]) : null;
  }
  function setCookie(name, value, days) {
    var exp = days ? '; max-age=' + days * 86400 : '';
    d.cookie = name + '=' + encodeURIComponent(value) + exp + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }
  function randomId() {
    var a = new Uint8Array(12), s = '', abc = 'abcdefghijklmnopqrstuvwxyz0123456789';
    (w.crypto || w.msCrypto).getRandomValues(a);
    for (var i = 0; i < a.length; i++) s += abc[a[i] % abc.length];
    return s;
  }
  function parsePairs(v) {
    var out = {};
    (v || '').split('|').forEach(function (p) { var kv = p.split(':'); if (kv[0] && /^[A-Z]$/.test(kv[1] || '')) out[kv[0]] = kv[1]; });
    return out;
  }
  function pairs(o) { return Object.keys(o).sort().map(function (k) { return k + ':' + o[k]; }).join('|'); }
  function send(payload) {
    try {
      var body = JSON.stringify(payload);
      if (!(navigator.sendBeacon && navigator.sendBeacon(API, new Blob([body], { type: 'text/plain' })))) {
        fetch(API, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: body });
      }
    } catch (e) { /* rien */ }
  }
  function session(key, compute) {
    try {
      var v = sessionStorage.getItem(key);
      if (v === null) { v = compute(); sessionStorage.setItem(key, v); }
      return v;
    } catch (e) { return compute(); }
  }
  function sget(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
  function sset(key, value) { try { sessionStorage.setItem(key, value); } catch (e) { /* rien */ } }

  // Prévisualisation : « ?ab=slug:B&abk=<clé> ». Le cookie _el_ab_force vaut « ok|slug:B » ; sans previewHash dans la config, rien n'est jamais forcé.
  function parseForce(v) {
    var parts = (v || '').split('|');
    return parts[0] === 'ok' ? parsePairs(parts.slice(1).join('|')) : {};
  }

  function run() {
    var el = d.getElementById('el-ab-config');
    if (!el) return;
    var raw = JSON.parse(el.textContent || '{}') || {};
    var cfg = raw.config || { tests: [], retired: [] };
    var tests = cfg.tests || [];
    var retired = cfg.retired || [];

    var previewOk = typeof cfg.previewHash === 'number';
    if (previewOk) {
      var ab = location.search.match(/[?&]ab=([^&]+)/), abk = location.search.match(/[?&]abk=([^&]+)/);
      if (ab && abk && fnv1a(safeDecode(abk[1])) === cfg.previewHash) setCookie('_el_ab_force', 'ok|' + safeDecode(ab[1]).replace(/,/g, '|'));
    }
    var force = previewOk ? parseForce(getCookie('_el_ab_force')) : {};
    var forced = Object.keys(force).length > 0;
    if (!forced && BOT.test(navigator.userAgent)) return;

    var vid = getCookie('_el_vid');
    if (vid && !/^[a-z0-9]{8,40}$/.test(vid)) vid = null; // cookie illisible : nouveau visiteur
    var returning = !!vid;
    if (!vid) {
      vid = randomId();
      setCookie('_el_vid', vid, 365);
      if (getCookie('_el_vid') !== vid) return; // cookies bloqués : le visiteur ne serait jamais le même d'une page à l'autre
    }
    var stored = parsePairs(getCookie('_el_ab'));
    var path = stripLocale(location.pathname);
    var country = /^[A-Z]{2}$/.test(raw.country || '') ? raw.country : null; // le dashboard refuse tout autre format
    var device = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
    var source = session('el_ab_src', function () {
      var u = location.search.match(/[?&]utm_source=([^&]+)/);
      try { if (u) return decodeURIComponent(u[1]).toLowerCase().slice(0, 60) || 'direct'; } catch (e) { /* utm illisible : on passe au referrer */ }
      try { return d.referrer ? new URL(d.referrer).hostname.replace(/^www\./, '').slice(0, 60) : 'direct'; } catch (e) { return 'direct'; }
    });
    var landing = session('el_ab_land', function () { return path.slice(0, 200); });

    var active = {}, classes = [], codes = [], exposures = [];
    tests.forEach(function (t) {
      try { // un test mal formé n'empêche pas les autres
        if (!t || !t.slug || !t.split || !Object.keys(t.split).length) return;
        var pages = t.pages || [], countries = t.countries || [], tcodes = t.codes || {};
        var v;
        if (forced) {
          v = force[t.slug];
          if (!v || !has(t.split, v)) return;
        } else {
          v = stored[t.slug];
          if (v && !has(t.split, v)) v = null; // version retirée : nouvelle répartition
          if (!v) {
            if (countries.length && countries.indexOf(country) < 0) return;
            if (pages.length && !pages.some(function (p) { return glob(p, path); })) return;
            v = pick(t.split, bucket(vid, t.slug));
            stored[t.slug] = v;
            exposures.push({ type: 'exposure', vid: vid, test: t.slug, variant: v, country: country, device: device, source: source, landing: landing, returning: returning });
          }
        }
        active[t.slug] = v;
        classes.push('ab-' + t.slug + '-' + v);
        if (tcodes[v]) codes.push(tcodes[v]);
      } catch (e) { /* test ignoré */ }
    });
    classes.forEach(function (c) { d.documentElement.classList.add(c); });

    // On ne garde en cookie que les tests encore actifs.
    var keep = {};
    tests.forEach(function (t) { if (t && t.slug && stored[t.slug]) keep[t.slug] = stored[t.slug]; });
    if (!forced) setCookie('_el_ab', pairs(keep), 90);
    for (var i = 0; i < exposures.length; i += 5) send(exposures.slice(i, i + 5));

    var names = Object.keys(active).sort();
    if (!names.length && !retired.length) return; // rien à écrire dans le panier
    var attr = names.length && !forced ? ['vid=' + vid].concat(names.map(function (k) { return k + '=' + active[k]; })).join(';') : null;
    syncCart(attr, codes, retired);
  }

  function getJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }

  // Dernier recours si le panier refuse le code : le cookie de /discount/<code> l'applique à la commande.
  function discountFallback(code) {
    var key = 'el_ab_disc_' + code;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (e) { return; }
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' }).catch(function () { /* rien */ });
  }

  // Attribut _ab, codes des versions et retrait des codes de tests arrêtés.
  // Avec des codes : le panier est revérifié à chaque page (nouveau panier après une commande). Sans code : une fois par session et par panier.
  function syncCart(attr, codes, retired) {
    var token = getCookie('cart') || '';
    var sig = (attr || '') + '#' + retired.join(',') + '#' + token;
    if (!codes.length && sget('el_ab_cart') === sig) return;
    var retiredLow = retired.map(low);
    var updated = true;
    getJson('/cart.js').then(function (cart) {
      var current = (cart.discount_codes || []).map(function (c) { return c.code; });
      var kept = current.filter(function (c) { return retiredLow.indexOf(low(c)) < 0; });
      var keptLow = kept.map(low);
      var missing = codes.filter(function (c, i) { return keptLow.indexOf(low(c)) < 0 && codes.indexOf(c) === i; });
      // Déjà essayé avec ce panier pendant la session : on n'insiste pas (panier vide, code refusé).
      var tryKey = token + ':' + missing.join(',');
      if (missing.length && sget('el_ab_try') === tryKey) missing = [];
      kept = kept.concat(missing);
      var body = {};
      if (attr && (cart.attributes || {})._ab !== attr) body.attributes = { _ab: attr };
      if (kept.length !== current.length || missing.length) body.discount = kept.join(',');
      if (!body.attributes && body.discount === undefined) return;
      if (missing.length) sset('el_ab_try', tryKey);
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.ok ? r.json() : null; }, function () { return null; })
        .then(function (after) {
          updated = !!after;
          missing.forEach(function (c) {
            var hit = after && (after.discount_codes || []).filter(function (x) { return low(x.code) === low(c); })[0];
            if (!hit || hit.applicable === false) discountFallback(c);
          });
        });
    }).then(function () {
      // Mise à jour refusée ou en erreur : la signature n'est pas mémorisée, la page suivante réessaie.
      if (updated) sset('el_ab_cart', sig);
    }).catch(function () { /* la commande sera rattachée par le pixel */ });
  }

  try {
    run();
  } catch (e) {
    try {
      if (!sessionStorage.getItem('el_ab_err')) { sessionStorage.setItem('el_ab_err', '1'); send({ type: 'error', message: String(e && e.message || e).slice(0, 300) }); }
    } catch (x) { /* rien */ }
  }
})(window);
